export enum Integrations {
  PANEL = 'panel',
  SHOPER = 'shoper',
  SHOPIFY = 'shopify',
  PIPEDRIVE = 'pipedrive',
  ALLEGRO = 'allegro',
  ZAPIER = 'zapier',
  BASELINKER = 'baselinker',
  PRESTASHOP = 'prestashop',
  ERECRUITER = 'erecruiter',
  TRAFFIT = 'traffit',
  APILO = 'apilo',
  CUSTOM = 'custom',
}
